<template>
  <gg-card class-name="fill-height">
    <gg-card-header>
      {{ title }}
    </gg-card-header>
    <gg-card-text>
      <v-row v-if="type === 'month'">
        <v-col cols="12" class="pb-0">
          Reporting Period: <b>{{ reportingPeriod }}</b>
        </v-col>
        <v-col cols="12" class="pb-0">
          Signups this Period: <b>{{ overview.signUps }}</b>
        </v-col>
        <v-col cols="12" class="pb-0">
          Payout per Signup: <b>{{ moneyFormat(overview.payout) }}</b>
        </v-col>
        <v-col cols="12">
          Earnings this Period: <b>{{ moneyFormat(overview.earnings) }}</b>
        </v-col>
      </v-row>
    </gg-card-text>
  </gg-card>
</template>

<script>
import { mapGetters } from 'vuex'
import format from 'date-fns/format'
import { moneyFormat } from '@/helpers/helpers'

export default {
  name: 'AccountOverview',
  props: {
    type: {
      type: String,
      required: true,
      default: 'month'
    },
    title: {
      type: String,
      required: true
    }
  },
  computed: {
    ...mapGetters({
      reportingDate: 'affiliates/reportingDate',
      overview: 'affiliates/overview'
    }),
    reportingPeriod () {
      const dateFormat = 'MMMM yyyy'
      return format(new Date(), dateFormat)
    }
  },
  methods: {
    moneyFormat
  }
}
</script>

<style scoped>

</style>
